module.exports = __webpack_public_path__ + "b18fda9aefe060d1f9e2f4401a6635f3.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/icones_app/today-signal.png
// module id = 680
// module chunks = 0